// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"eb0bb867","320":"ce55fee5","334":"6772f62b","455":"6dc23671","633":"265e2f98","701":"4834427b","724":"aaaee4e1","766":"89ef1fc2","932":"85fdf979","977":"6b744e58"}[chunkId] + ".chunk.js";
};